// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__1jMgb","title":"AfterBackImages_title__2dRJe","images":"AfterBackImages_images__3Smde"};